import { useContext } from "react";
import BryntumContext from "../context/bryntumContext.jsx";
import AuthContext from "../context/authContext.jsx";
import AlertNotificationBanner from "../components/alertNotificationBanner/AlertNotificationBanner.jsx";
import ContextPageView from "../components/entityViews/context/ContextPageView";

const ContextPage = () => {
  const { project, editorHandler } = useContext(BryntumContext);
  const { user } = useContext(AuthContext);

  return (
    <div className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0" id="context-page">
      {user && (
        <div className="shrink-0">
          {/* @ts-expect-error — JS module, no type definitions */}
          <AlertNotificationBanner project={project} editorHandler={editorHandler} user={user} />
        </div>
      )}
      <div className="flex-1 min-h-0">
        <ContextPageView />
      </div>
    </div>
  );
};

export default ContextPage;
